var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("一个有意识的，综合性和补充性的饮食只能给你的生活带来幸福。")]),_vm._v(" "),_c('p',[_vm._v("在生物能源中心，我们有必要的工具，将引导您实现所有目标，以及最佳的健康，与最好的天然产品和少量运动相补充，我们一定是最好的，我们还将根据您的需要进行营养评估、身体评估、饮食计划以及后续跟进。")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c754c3d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s2.vue
// module id = null
// module chunks = 